import { MONTHS } from "./constants";
const isEndDateValid = ({ start_year, start_month, end_year, end_month }) => {
  if (!end_year) return true;
  if (end_year > start_year) return true;
  if (end_year === start_year && start_month && end_month) {
    return MONTHS.indexOf(end_month) >= MONTHS.indexOf(start_month);
  }
  return end_year === start_year;
};

export function validateEducation(values) {
  return values.map((item, idx) => {
    if (!item.college) {
      return { idx, error: "University / School is required", name: "college" };
    }
    if (!item.level) {
      return { idx, error: "Degree is required", name: "level" };
    }
    if (!item.degree) {
      return { idx, error: "Field of study is required", name: "degree" };
    }
    if (!item.start_year) {
      return { idx, error: "Start year is required", name: "start_year" };
    }
    if (!item.is_current) {
      if (!item.end_year) {
        return { idx, error: "End year is required", name: "end_year" };
      }

      if (!isEndDateValid(item)) {
        return {
          idx,
          error: "End date should not be less than start date",
          name: "end_year",
        };
      }
    }
    if (item.cgpa) {
      // check if cgpa is a decimal number
      if (isNaN(item.cgpa)) {
        return { idx, error: "CGPA should be a number", name: "cgpa" };
      }

      // scale is required
      if (!item.cgpa_scale) {
        return { idx, error: "Out of (Scale) is required", name: "cgpa_scale" };
      }

      // it should be less than cgpa_scale
      if (item.cgpa > item.cgpa_scale) {
        return {
          idx,
          error: "CGPA should not be greater than out of (Scale)",
          name: "cgpa",
        };
      }
    }

    if (item.cgpa_scale) {
      if (!item.cgpa) {
        return { idx, error: "CGPA is required", name: "cgpa" };
      }
    }

    return null;
  }).filter(error => error)
}
